import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.UserActionsToolbar.UserMenuActivator', {
    hasInvitations: 'You have invitations',
    manyDelegates: '{count} persons',
    delegatedTo: 'Delegated to:',
});
